module.exports = __webpack_public_path__ + "assets/img/logo-full.ce040705.png";